// Public Routes
export const SIGN_IN = "/login";
export const SIGN_UP = "/";

// Private Routes
export const HOME = "/home";
